import { useState } from "react";
import HelpModal from "../../../components/Modals/HelpModal";
import { FeedbackIcon, SuccessCelebrationIcon } from "../../icons";
import { formatSwapAmount } from "../../utils/format";
// import { formatCryptoAmount } from "../../utils/format";

const SwapSuccessStep = ({ toAsset, toAmount, fromAsset, fromAmount, onCheckAssets }) => {
  const [helpModalOpen, setHelpModalOpen] = useState(false);
  return(
  <div className="flex h-full min-h-0 flex-col overflow-y-auto hide-scrollbar px-6 pb-6  sm:pt-2 pt-[80px] font-outfit">
    <div className="flex -mt-4 flex-col items-center gap-2">
      <div className="flex flex-col items-center w-full space-y-10">
        <SuccessCelebrationIcon className="-mb-10"/>
    
        <div className="flex w-full flex-col items-center gap-20">
          <div className="flex flex-col items-center gap-2 text-center">
            <p className="text-base font-medium  text-text-primary">
              Swap Successful
            </p>
            <p className="text-[28px] font-medium pt-1 text-text-primary">
              {formatSwapAmount(toAmount, toAsset?.currency_code)}
              {/* {toAmount} {toAsset?.currency_code} */}
            </p>
            <p className="text-xs font-medium pt-1 text-text-secondary">
              Swap assets are now in your account
            </p>
          </div>
    
          <button
            type="button"
            onClick={onCheckAssets}
            className="flex h-12 w-full items-center justify-center rounded-[10px] bg-[#4ab933] text-sm font-semibold leading-[21px] text-white custom-transition hover:bg-[#3fa82c]"
          >
            Check Accounts
          </button>
        </div>
      </div>
  
      <div className="mx-auto flex w-full flex-col items-center  sm:pt-2 pt-[40px]">
        <HelpModal
          HelpModalOpen={helpModalOpen}
          setHelpModalOpen={setHelpModalOpen}
          className={"w-full"}
        >
          <button
            type="button"
            className="flex h-12 w-full items-center justify-between rounded-[10px] border border-divider px-4 py-2.5 custom-transition hover:bg-option-hover"
          >
            <span className="text-sm font-medium leading-[19.5px] text-text-primary">
              Provide Feedback
            </span>
            <FeedbackIcon />
          </button>
        </HelpModal>
      </div>
    </div>
  </div>
  );
}

export default SwapSuccessStep;
